var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthBackground(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1361,
    height: 609,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    transform: "rotate(-7 4291.342 278.88)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CFDAE6",
    opacity: 0.25,
    cx: 63.575,
    cy: 32.468,
    rx: 21.783,
    ry: 21.766
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CFDAE6",
    opacity: 0.6,
    cx: 5.987,
    cy: 13.867,
    rx: 5.217,
    ry: 5.213
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.135 88.352c5.763 0 10.435-4.668 10.435-10.427 0-5.758-4.672-10.426-10.435-10.426-5.763 0-10.434 4.668-10.434 10.426 0 5.759 4.671 10.427 10.434 10.427z",
    fill: "#CFDAE6",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.278 33.17l54.908-16.605",
    stroke: "#CFDAE6",
    strokeWidth: 1.739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.143 26.5L7.712 14.564",
    stroke: "#E0B4B7",
    strokeWidth: 0.703,
    opacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.405357899873153,2.108036953469981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.926 33.522L43.672 69.325",
    stroke: "#BACAD9",
    strokeWidth: 0.703,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.405357899873153,2.108036953469981"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 60.031 230.21)",
    fill: "#CFDAE6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 9.135,
    cy: 9.128,
    rx: 9.135,
    ry: 9.128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.128c0 5.04 4.09 9.127 9.135 9.127s9.135-4.086 9.135-9.127H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5 462.48 -1092.758)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CFDAE6",
    opacity: 0.25,
    cx: 29.118,
    cy: 29.14,
    rx: 29.118,
    ry: 29.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CFDAE6",
    opacity: 0.3,
    cx: 29.118,
    cy: 29.14,
    rx: 21.569,
    ry: 21.585
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#CFDAE6",
    opacity: 0.4,
    cx: 179.02,
    cy: 138.146,
    rx: 23.725,
    ry: 23.744
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#BACAD9",
    opacity: 0.5,
    cx: 29.118,
    cy: 29.14,
    rx: 10.784,
    ry: 10.793
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.118 39.933V18.348c-5.956 0-10.785 4.832-10.785 10.792s4.829 10.793 10.785 10.793z",
    fill: "#BACAD9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    transform: "translate(172 131)",
    fill: "#E6A1A6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.02,
    cy: 7.146,
    rx: 6.471,
    ry: 6.476
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02 13.622c-3.574 0-6.471-2.9-6.471-6.476A6.473 6.473 0 017.019.671v12.951z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CFDAE6",
    cx: 218.382,
    cy: 138.686,
    rx: 1.618,
    ry: 1.619
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E0B4B7",
    opacity: 0.35,
    cx: 179.559,
    cy: 175.381,
    rx: 1.618,
    ry: 1.619
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E0B4B7",
    opacity: 0.35,
    cx: 180.098,
    cy: 102.53,
    rx: 2.157,
    ry: 2.159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.999 29.967L171.15 132.876",
    stroke: "#CFDAE6",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    transform: "rotate(-11 517.26 -5290.613)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#CFDAE6",
    strokeWidth: 0.941,
    cx: 43.814,
    cy: 32,
    rx: 11.186,
    ry: 11.294
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.597 23.111)",
    fill: "#BACAD9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 9.185,
    cy: 8.889,
    rx: 8.475,
    ry: 8.556
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.185 17.445c4.68 0 8.475-3.83 8.475-8.556 0-4.726-3.794-8.556-8.475-8.556v17.112z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.66 24.81L5.717 4.769",
    stroke: "#CFDAE6",
    strokeWidth: 0.941
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#CFDAE6",
    strokeWidth: 0.941,
    cx: 3.263,
    cy: 3.294,
    rx: 3.263,
    ry: 3.294
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7E1AD",
    cx: 2.797,
    cy: 61.176,
    rx: 2.797,
    ry: 2.824
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.631 39.292L5.064 59.785",
    stroke: "#CFDAE6",
    strokeWidth: 0.941
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33,
    transform: "rotate(-10 2530.52 -6239.949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-85 127.141 -12.32)",
    fill: "#BACAD9"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 11.667,
    cy: 11.667,
    r: 11.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.667c0 6.443 5.223 11.666 11.667 11.666 6.443 0 11.666-5.223 11.666-11.666H0z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFDAE6",
    cx: 201.833,
    cy: 87.5,
    r: 5.833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 88.813l11.57-71.21M17.5 37.333l109.966 60.312",
    stroke: "#BACAD9",
    strokeWidth: 1.167
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CFDAE6",
    strokeWidth: 1.167,
    d: "M143.903 120.302l31.032 111.27L38.5 147.51l87.867-36.678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.833 99.745l35.584-10.495",
    stroke: "#E0B4B7",
    strokeWidth: 1.167,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.333 82.137l33.386-45.97",
    stroke: "#BACAD9",
    strokeWidth: 1.167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.723 132.232l-59.64-41.815",
    stroke: "#CFDAE6",
    strokeWidth: 1.167
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1D1E0",
    cx: 156.917,
    cy: 8.75,
    r: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1D1E0",
    cx: 39.083,
    cy: 148.75,
    r: 5.25
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.6,
    fill: "#D1DEED",
    cx: 8.75,
    cy: 33.25,
    r: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.6,
    fill: "#D1DEED",
    cx: 243.833,
    cy: 30.333,
    r: 5.833
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E0B4B7",
    cx: 175.583,
    cy: 232.75,
    r: 5.25
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth-background.40d7f08be7ee66d819b4cb16aa270e6c.svg";
export { ForwardRef as ReactComponent };